/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import BackButton from '../../editors/controls/BackButton';
import {SaveButton} from '../../editors/controls/SaveButton';

interface IonStepperActionButtonsProps {
  onPrimary: MouseEventHandler;
  onSecondary: MouseEventHandler;
  primaryLabel: string;
  disableSecondary: boolean;
  isPrimaryLoading: boolean;
  disabled?: boolean;
};

/**
 * Buttons to be displayed as dialog actions focused towards 'Stepper' variant actions ('Next', 'Back', etc)
 */
export const IonStepperActionButtons = ({
  onPrimary,
  onSecondary,
  primaryLabel,
  isPrimaryLoading,
  disableSecondary,
  disabled = false
}: IonStepperActionButtonsProps) => (
  <>
    <BackButton onBack={onSecondary} disabled={disableSecondary} />
    <SaveButton onSave={onPrimary} label={primaryLabel} loading={isPrimaryLoading} disabled={disabled} />
  </>
);

export default IonStepperActionButtons;
